import { __exports as lib } from '../../../_virtual/index3.js';
import './Scrollbars/index.js';
import { __exports as Scrollbars } from '../../../_virtual/index5.js';
(function (exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Scrollbars = undefined;
  var _Scrollbars = Scrollbars;
  var _Scrollbars2 = _interopRequireDefault(_Scrollbars);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }
  exports["default"] = _Scrollbars2["default"];
  exports.Scrollbars = _Scrollbars2["default"];
})(lib);